import { CREATEJS_UTILITIES_LOGGER } from "../../index";
import { getLogger } from "@goodgamestudios/logger";
import DisplayObject = createjs.DisplayObject;

export class BlitMask {

    private logger = getLogger(CREATEJS_UTILITIES_LOGGER);

    public autoUpdate: boolean = false;
    public bitmapMode: boolean = false;
    public fillColor: number = 0;
    public width: number = 0;
    public height: number = 0;
    public rotation: number = 0;
    public scaleX: number = 0;
    public scaleY: number = 0;
    public scrollX: number = 0;
    public smoothing: boolean = false;
    public target: DisplayObject;
    public wrap: boolean = false;
    public wrapOffsetX: number = 0;
    public wrapOffsetY: number = 0;
    public x: number = 0;
    public y: number = 0;

    public constructor(
        target: DisplayObject,
        x: number = 0,
        y: number = 0,
        width: number = 100,
        height: number = 100,
        smoothing: boolean = false,
        autoUpdate: boolean = false,
        fillColor: number = 0x00000000,
        wrap: boolean = false) {
        this.logger.debug("BlitMask not implemented yet");
    }

    public disableBitmapMode(event: Event | null = null): void {
        // to be implemented
        this.logger.debug("BlitMask.disableBitmapMode not implemented yet");
    }

    public dispose(): void {
        // to be implemented
        this.logger.debug("BlitMask.dispose not implemented yet");
    }

    public enableBitmapMode(event: Event | null = null): void {
        // to be implemented
        this.logger.debug("BlitMask.enableBitmapMode not implemented yet");
    }

    public normalizePosition(): void {
        // to be implemented
        this.logger.debug("BlitMask.normalizePosition not implemented yet");
    }

    public update(event: Event | null = null, forceRecaptureBitmap: boolean = false): void {
        // to be implemented
        this.logger.debug("BlitMask.update not implemented yet");
    }
}
